function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFAF20",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.5 29c2.571 0 8.571-3.36 8.571-8.4 2.572 0 2.572-5.04 0-5.04l-.857-4.2c-6.857 0-6.857-2.52-7.714-3.36-.857.84-.857 3.36-7.714 3.36l-.857 4.2c-2.572 0-2.572 5.04 0 5.04 0 5.04 6 8.4 8.571 8.4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.142 16l.845-6.398S33.794 1 22.5 1 12.013 9.602 12.013 9.602l.86 6.358M17.49 28L7.289 31C4.71 31.935 3 34.324 3 36.996V41h38v-4.003c0-2.672-1.708-5.06-4.287-5.998L26.513 28"
}));

var SvgSelfieIcon = function SvgSelfieIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelfieIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/selfie_icon.6ee9c44b.svg";
export { ForwardRef as ReactComponent };